import obtenerContribuyente from "../contribuyente/contribuyente/obtenerContribuyente";
import { generarPDFPorFolio } from "../pdf/generarPDFPorFolio";

export default function obtenerPolizaPorIdPoliza (idPoliza, setData) {
    const endpoint = `/api/poliza/ObtenerOrdenPagoPorIdPoliza/${idPoliza}`;
    fetch(endpoint)
        .then(responsePoliza => responsePoliza.ok && responsePoliza.json())
        .then(async dataPoliza => {
            const idContribuyente = dataPoliza.data[0].idContribuyente;
            const polizas = dataPoliza.data;
            const finalData = await obtenerContribuyente(idContribuyente, setData);
            generarPDFPorFolio(polizas, finalData);
            
            /* fetch(`/api/contribuyente/ContribuyentePorIdContribuyente/${idContribuyente}`)
                .then(responseContribuyente => responseContribuyente.ok && responseContribuyente.json())
                .then(async dataContribuyente => {
                    const dataObject = {
                        nombre: dataContribuyente.data.nombre,
                        apellidoPaterno: dataContribuyente.data.apellidoPaterno,
                        apellidoMaterno: dataContribuyente.data.apellidoMaterno,
                        rfc: dataContribuyente.data.rfc
                    }
                    const finalData = await buscarConcesionarioPorContribuyente(dataObject, setData);
                    generarPDFPorFolio(polizas, finalData);
                })
                .catch(error => console.error(error)); */
        })
        .catch(error => console.error(error));
}